import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'normalizeBookingStatus'
})
export class NormalizeBookingStatusPipe implements PipeTransform {

  transform(value: string, arg?: string): string {
    switch (value) {
      case 'studio-declined':
        return 'Studio Declined';
      case 'studio-confirmed':
        return 'Studio Confirmed';
      case 'pending-confirmation':
        return 'Pending confirmation from Studio';
      case 'planning':
        return 'Pending confirmation from Bandmates';
      case 'planning-complete':
        return 'Bandmates Confirmed - Action required';
      case 'user-declined':
        return 'Bandmates Canceled';
      case 'user-canceled':
        return 'Canceled';
      case 'studio-canceled':
        return 'Studio Canceled';
      default:
        return 'Pending';
    }
  }

}
